var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgResidencyPermit = function SvgResidencyPermit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.5V7.24C17 6.45593 17 6.06389 16.8474 5.76441C16.7132 5.50099 16.499 5.28681 16.2356 5.15259C15.9361 5 15.5441 5 14.76 5H5.24C4.45593 5 4.06389 5 3.76441 5.15259C3.50099 5.28681 3.28681 5.50099 3.15259 5.76441C3 6.06389 3 6.45593 3 7.24V12.56C3 13.3441 3 13.7361 3.15259 14.0356C3.28681 14.299 3.50099 14.5132 3.76441 14.6474C4.06389 14.8 4.45593 14.8 5.24 14.8H9.3M5.8 8.5H13.85M5.8 10.6H10.35",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9303 11.8843L13.4424 15.3721C13.4082 15.4063 13.3528 15.4063 13.3187 15.3721L12.1006 14.1541",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })));
};
export default SvgResidencyPermit;